import { useQuery } from "@apollo/client/react";

import { inboxOwnedTeams } from "./ownedTeams.graphql";
import { ownedTeamIds, type OwnedMembership } from "./ownedTeams";

type OwnedTeamsQuery = {
  userPerson?: {
    memberships?: OwnedMembership[] | null;
  } | null;
};

export type InboxOwnedTeams = {
  ownedTeamIds: string[];
  loading: boolean;
  error: boolean;
};

export const useInboxOwnedTeamIds = (enabled: boolean): InboxOwnedTeams => {
  const { data, loading, error } = useQuery<OwnedTeamsQuery>(inboxOwnedTeams, {
    skip: !enabled,
  });
  return {
    ownedTeamIds: ownedTeamIds(data?.userPerson?.memberships),
    loading,
    error: error != null,
  };
};
